/** @jsxImportSource @emotion/react */

import tw from "twin.macro";

import { CalciteTooltip } from "@esri/calcite-components-react";
import React from "react";

const SystemGenerated: React.FC<any> = (data) => {
  const originalData = {
    "Telephone Number": data?.error?.TELEPHONENUMBER,
    "Call Type": data?.error?.CALLTYPE,
    "ALI Timestamp": data?.error?.ALI_TIMESTAMP,
    "Caller Name": data?.error?.CALLERNAME,
    "Street Address": data?.error?.STREETADDRESS,
    Location: data?.error?.LOCATIONINFO,
    Community: data?.error?.COMMUNITY,
    Latitude: data?.error?.LATITUDE,
    Longitude: data?.error?.LONGITUDE,
    X: data?.error?.X,
    Y: data?.error?.Y,
    ESN: data?.error?.ESN,
    FIR: data?.error?.E911FIRERESPONDER,
    LAW: data?.error?.E911LAWENFORCEMENTRESPONDER,
    EMS: data?.error?.E911MEDICALRESPONDER,
  };

  return (
    <div css={[tw`col-span-2`]}>
      <h3 css={[tw`mb-4`]}>System Generated</h3>
      <div css={[tw`grid w-full grid-cols-2 gap-4 items-start`]}>
        <div
          css={[tw`border border-gray-300 rounded-md overflow-hidden h-full`]}
        >
          <table css={[tw`w-full table-fixed text-sm h-full`]}>
            <thead css={[tw`bg-gray-200 border-b border-gray-400`]}>
              <tr>
                <th css={[tw`border-r border-gray-400 py-1 px-2 w-1/3`]}>
                  Field
                </th>
                <th css={[tw`font-semibold py-1 px-2 w-2/3`]}>Value</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(originalData).map((field) => (
                <tr key={field} css={[tw`border-b border-gray-300`]}>
                  <td
                    css={[
                      tw`font-semibold border-r border-gray-400 py-0.5 px-2`,
                    ]}
                  >
                    {field}
                  </td>
                  <td css={[tw`py-0.5 px-2`]}>{originalData[field]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div
          css={[
            tw`border border-gray-300 rounded-md overflow-hidden h-full flex flex-col`,
          ]}
        >
          <div css={[tw`flex-1`]}>
            <CalciteTooltip referenceElement={"ali"} placement="right">
              Copy to Clipboard
            </CalciteTooltip>
            <div css={[tw`border-b border-gray-300 bg-gray-200 p-2`]}>
              <h3
                id="ali"
                css={[tw`cursor-pointer w-fit m-0`]}
                onClick={() =>
                  navigator.clipboard.writeText(data?.error?.ALI || "")
                }
              >
                ALI
              </h3>
            </div>
            <div css={tw`p-2`}>
              <pre css={tw`whitespace-pre-wrap break-normal`}>
                {data?.error?.ALI}
              </pre>
            </div>
          </div>
          <div css={[tw`flex-1`]}>
            <div css={[tw`border-b border-gray-300 bg-gray-200 p-2`]}>
              <h3 css={[tw` w-fit m-0`]}>Geoprocessing Result</h3>
            </div>
            <div css={tw`p-2`}>
              <pre css={tw`whitespace-pre-wrap break-normal`}>
                {data?.error?.GEOPROCESSINGRESULT}
              </pre>
            </div>
          </div>
          <div css={[tw`flex-1`]}>
            <div css={[tw`border-b border-gray-300 bg-gray-200 p-2`]}>
              <h3 css={[tw` w-fit m-0`]}>Error Description</h3>
            </div>
            <div css={tw`p-2`}>
              <pre css={tw`whitespace-pre-wrap break-normal`}>
                {data?.error?.ERRORDESCRIPTION}
              </pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemGenerated;
